import React from "react";

const LeftFlap = () => {
  return (
    <svg
      className="left-flap"
      viewBox="0 0 185 325"
      preserveAspectRatio="none"
    >
      <path
        d="
          M 0 325
          L 0 0
          L 185 162
          Z
        "
        fill="currentColor"
      />
    </svg>
  );
};

export default LeftFlap;